import React from 'react';
import Modal from '../../../../../components/Modal';
import Table from '../../../../../components/table/Table';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import WidgetItemListWrap from '../../WidgetItemListWrap';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  WIDGET_ITEM_LINK_ID_LIST_FILTER_OPTION_MODEL,
  WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/widget/models';
import {
  SELECTED_SEARCH_REVIEW_LIST_TABLE_EMPTY_TEXT,
  SEARCH_REVIEW_LIST_TABLE_EMPTY_TEXT,
} from '../../../../../constants/service/app/widgetConstants';
import { columns } from './columns';

const SearchReviewListModal = (props) => {
  const { isOpen, closeModal, onSubmit, getReviewList, data, onCheckReview, selectedReviewList, selectedReviewIdList } =
    props;
  const { listData, linkType } = data;
  const { list, filterOption, sortOption, pagination, summary = {} } = listData;

  return (
    <Modal
      title="상품 후기 검색"
      isOpen={isOpen}
      width={1500}
      height={650}
      isFooter={true}
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="search-review-list-modal-wrap">
        <WidgetItemListWrap title="선택된 상품 후기">
          <Table
            className="selected-review-list-table"
            emptyText={SELECTED_SEARCH_REVIEW_LIST_TABLE_EMPTY_TEXT}
            data={selectedReviewList}
            sortable={false}
            defaultPageSize={1}
            isUsedAllCheck={false}
            isUsedCheckbox={true}
            checkedIdList={selectedReviewIdList}
            onCheck={(list) => onCheckReview(list)}
            columns={() => columns({})}
          />
        </WidgetItemListWrap>

        <WidgetItemListWrap title="상품 후기 리스트">
          <TableWithSummary
            className="review-list-table"
            totalCnt={summary.totalCnt}
            emptyText={SEARCH_REVIEW_LIST_TABLE_EMPTY_TEXT}
            initialOption={{
              filterOption: WIDGET_ITEM_LINK_ID_LIST_FILTER_OPTION_MODEL[linkType],
              sortOption: WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL[linkType],
              pagination: LIST_PAGINATION_MODEL,
            }}
            data={list}
            maxHeight={380}
            showPagination
            filterOption={filterOption}
            sortOption={sortOption}
            pagination={pagination}
            getList={getReviewList}
            isUsedAllCheck={false}
            isUsedCheckbox={true}
            checkedIdList={selectedReviewIdList}
            onCheck={(list) => onCheckReview(list)}
            columns={(utils) => columns(utils)}
            getTdProps={(state, rowInfo) => {
              return {
                className: selectedReviewIdList.includes(rowInfo.original.id) ? 'selected' : '',
              };
            }}
          />
        </WidgetItemListWrap>
      </div>
    </Modal>
  );
};

export default SearchReviewListModal;
